// Every number the rules of Can't Stop depend on, in one place.
//
// Sourced from docs/rules.pdf (a complete rules writeup of Sid Sackson's
// game, the one shipped to players of the TTS mod era of the game's
// out-of-print years) and docs/board.png (the board itself, from the TTS
// mod - the column heights are printed on it and nowhere else). Page
// references below are to rules.pdf. Nothing here is from memory.

// "Roll all four dice, then combine them into two pairs, any way you wish."
// (p1, Rolling)
export const DICE_COUNT = 4;

// "You should have ... three white cubes" (p1, Setup) - the three runners
// that mark progress during a turn. The third runner is the whole game:
// once all three are placed, any roll that can't move one of THEM busts you.
export const RUNNER_COUNT = 3;

// "As soon as any player claims three columns, they win the game." (p1, Goal)
export const COLUMNS_TO_WIN = 3;

// "Each player chooses a color (red, green, blue, or yellow)" (p1, Setup) -
// four colors, so four seats. Two players is the printed minimum.
export const MIN_PLAYERS = 2;
export const MAX_PLAYERS = 4;

// How many steps each column takes to climb, keyed by the dice sum that
// advances it. Read off docs/board.png, not computed: 7 is the longest at 13
// spaces because it's the most likely sum, and the heights fall away by two
// per column out to the 3-space 2 and 12. (The arithmetic regularity is the
// board designer's, not ours - source stays the board.)
export const COLUMN_HEIGHTS = {
  2: 3, 3: 5, 4: 7, 5: 9, 6: 11, 7: 13, 8: 11, 9: 9, 10: 7, 11: 5, 12: 3,
};

// The eleven columns in board order. Every dice pair sums into this range.
export const COLUMNS = Object.keys(COLUMN_HEIGHTS).map(Number);

export const ACTION_TYPES = {
  ROLL: 'ROLL',
  CHOOSE_MOVE: 'CHOOSE_MOVE',
  STOP: 'STOP',
  ACK_BUST: 'ACK_BUST',
};

// Phases of one player's turn:
//  - rolling:  the player decides to roll again or stop and bank progress
//  - choosing: four dice are showing and the player picks a pairing
//  - busted:   the roll allowed no legal move; progress is lost, and the
//              engine waits for an ACK so the table gets to SEE the bust
//              before the seat passes (presentation needs the beat; the
//              reducer stays pure by making the beat a state).
export const TURN_PHASES = {
  ROLLING: 'rolling',
  CHOOSING: 'choosing',
  BUSTED: 'busted',
};

// Phases the game state can be in. `finished` is terminal.
export const PHASES = {
  PLAYING: 'playing',
  FINISHED: 'finished',
};
